import axios from "../api";

import useAuth from "./use-auth.js";

export default function useLogout() {
  const { resetAuth } = useAuth();

  async function logout() {
    try {
      await axios.post("/logout");
    } catch (err) {
      console.error(err);
    }
    resetAuth();
  }

  return logout;
}
